import UserProfileComponent from './UserProfile/index.vue'
import ContactsWindowComponent from './ContactsWindow/index.vue'
import UploadPublicFile from './UploadPublicFile/index.vue'

const ContactsComponents = {}

ContactsComponents.install = function(Vue) {
    Vue.component('UploadPublicFile', UploadPublicFile)
    // 封装install方法
    // 1. 创建组件构造器
    const UserProfileContrustor = Vue.extend(UserProfileComponent)
    const ContactsWindowContrustor = Vue.extend(ContactsWindowComponent)

    // 2. new  组件实例
    const userProfile = new UserProfileContrustor()
    const contactsWindow = new ContactsWindowContrustor()

    // 3. 将组件实例， 挂载到某一个元素上
    userProfile.$mount(document.createElement('div'))
    contactsWindow.$mount(document.createElement('div'))

    // 4. orgWindow.$el 对应的就是div
    // document.body.appendChild(userProfile.$el)
	window.userProfileEl = userProfile.$el
    // document.body.appendChild(contactsWindow.$el)
	window.contactsWindowEl = contactsWindow.$el

    // 5. 添加到原型链上
    Vue.prototype.$userProfile = userProfile
    Vue.prototype.$contactsWindow = contactsWindow
}

export default ContactsComponents
